import React, { useState, useEffect } from "react";

// Antd
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  notification,
  Spin,
  Radio,
} from "antd";

import TextArea from "antd/es/input/TextArea";
import { useSelector } from "react-redux";

// Quill
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';

import {
  addCourseContent,
  getCourseById,
} from "../../../../../../Constants/Api/functions/function";

const { Option } = Select;

const modules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ align: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image", "video"],
        ["clean"],
    ],
};

const AddContent = ({ isOpen, setOpen, courseId, hadleGetCourceContents }) => {
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [course, setCourse] = useState(null);
  const [installmentOptions, setInstallmentOptions] = useState([
    { value: 0, label: "0 (Free)" },
  ]);
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  useEffect(() => {
    if (isOpen && courseId) {
      fetchCourseDetails();
    }
  }, [isOpen, courseId]);

  const fetchCourseDetails = async () => {
    try {
      let courseData = await getCourseById(courseId);

      // Handle if courseData is an array
      if (Array.isArray(courseData)) {
        courseData = courseData[0];
      }

      if (courseData) {
        setCourse(courseData);
        const totalInstallments = courseData.installments || 0;
        const options = [];
        for (let i = 0; i <= totalInstallments; i++) {
          options.push({ value: i, label: i === 0 ? "(Free)" : `${i}` });
        }
        setInstallmentOptions(options);
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
    }
  };

  const onFinish = async (values) => {
    Object.keys(values).forEach(
      (key) =>
        (values[key] === undefined || values[key] === "") && delete values[key]
    );
    values.createdBy = userProfile.id;

    if (values.isPublished === "true") {
      values.isPublished = true;
    } else {
      values.isPublished = false;
    }

    if (values.isFree === true) {
      values.isFree = true;
    } else {
      values.isFree = false;
    }

    values.courseId = courseId;

    setIsLoading(true);

    try {
      const res = await addCourseContent(values);
      if (res && res.status === 200) {
        openNotification(
          "success",
          "Course content added",
          "New course content added successfully"
        );
        setOpen(false);
        await hadleGetCourceContents();
      }
    } catch (error) {
      console.error("AddCource", error);
    }

    setIsLoading(false);
  };

  const openNotification = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  return (
    <div>
      {contextHolder}
      <Drawer
        title="Add new course content"
        width={720}
        onClose={() => setOpen(false)}
        open={isOpen}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
      >
        <Spin spinning={isLoading} tip="Please wait...">
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Content Title"
              name="title"
              rules={[{ required: true, message: "Please input the title!" }]}
            >
              <Input showCount maxLength={200} placeholder="Content Title" />
            </Form.Item>
            <Form.Item label="Content Description" name="description">
              <ReactQuill
                modules={modules}
                theme="snow"
                placeholder="Content Description"
                style={{ height: '200px', marginBottom: '50px' }}
              />
            </Form.Item>
            <Form.Item label="Video ID" name="videoUrl">
              <Input showCount maxLength={500} placeholder="Video ID" />
            </Form.Item>
            <Form.Item label="Zoom Recording URL" name="zoomUrl">
              <Input
                showCount
                maxLength={500}
                placeholder="Zoom Recording URL"
              />
            </Form.Item>
            <Form.Item label="Drive URL" name="driveUrl">
              <Input showCount maxLength={500} placeholder="Drive URL" />
            </Form.Item>
            {/* <Form.Item
                            label="Is Free"
                            name="isFree"
                            rules={[{ required: true, message: 'Please check isFree!' }]}
                        >
                            <Radio.Group>
                                <Radio value={true}>Free</Radio>
                                <Radio value={false}>Paid</Radio>
                            </Radio.Group>
                        </Form.Item> */}
            <Form.Item
              label="Is Published"
              name="isPublished"
              rules={[{ required: true, message: "Please check isPublished!" }]}
            >
              <Select placeholder="Please select course content published status">
                <Option value="true">Published</Option>
                <Option value="false">Not Published</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Installments"
              name="installment"
              rules={[
                { required: true, message: "Please select installment!" },
              ]}
            >
              <Select
                placeholder="Please select installment level"
                options={installmentOptions}
              />
            </Form.Item>

            <Row gutter={16}>
              <Col>
                <Button
                  style={{ width: "100%" }}
                  type="primary"
                  htmlType="submit"
                >
                  Add Content
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Drawer>
    </div>
  );
};

export default AddContent;
